import React, { Component, Fragment } from "react";
import TextFormGroup from "assets/scripts/components/common/form/TextFormGroup/TextFormGroup";
import { defineMessages } from "react-intl";
import PhoneFormGroup from "assets/scripts/components/common/form/PhoneFormGroup/PhoneFormGroup";
import StateFormGroup from "assets/scripts/components/common/form/StateFormGroup/StateFormGroup";
const messages = defineMessages({
    firstNameLabel: {
        id: "forms.payNow.firstName.label",
        defaultMessage: "First Name"
    },
    lastNameLabel: {
        id: "forms.payNow.lastName.label",
        defaultMessage: "Last Name"
    },
    addressLabel: {
        id: "forms.payNow.address.label",
        defaultMessage: "Address"
    },
    address2Label: {
        id: "forms.payNow.address2.label",
        defaultMessage: "Address 2"
    },
    cityLabel: {
        id: "forms.payNow.city.label",
        defaultMessage: "City"
    },
    cityHelp: {
        id: "forms.payNow.city.help",
        defaultMessage: "Example: Springfield"
    },
    stateLabel: {
        id: "forms.payNow.state.label",
        defaultMessage: "State"
    },
    stateHelp: {
        id: "forms.payNow.state.help",
        defaultMessage: "Example: AK"
    },
    zipLabel: {
        id: "forms.payNow.zip.label",
        defaultMessage: "Zip"
    },
    zipHelp: {
        id: "forms.payNow.zip.help",
        defaultMessage: "Example: 12345"
    },
    phoneLabel: {
        id: "forms.payNow.phone.label",
        defaultMessage: "Phone"
    },
    phoneHelp: {
        id: "forms.payNow.phone.help",
        defaultMessage: "Example: 123-456-7890"
    },
    emailLabel: {
        id: "forms.payNow.email.label",
        defaultMessage: "Email"
    }
});
export default class PersonalInfoFields extends Component {
    constructor() {
        super(...arguments);
        this._handleFirstNameChange = (firstName) => this.props.onChange({ firstName });
        this._handleLastNameChange = (lastName) => this.props.onChange({ lastName });
        this._handleAddressChange = (address) => this.props.onChange({ address });
        this._handleAddress2Change = (address2) => this.props.onChange({ address2 });
        this._handleCityChange = (city) => this.props.onChange({ city });
        this._handleStateChange = (state) => this.props.onChange({ state });
        this._handleZipChange = (zip) => this.props.onChange({ zip });
        this._handlePhoneChange = (phone) => this.props.onChange({ phone });
        this._handleEmailChange = (email) => this.props.onChange({ email });
    }
    render() {
        const { props } = this;
        const { value, errors, backendErrors } = props;
        return (<Fragment>
				<TextFormGroup name="firstName" className="form-group-personalInfo-firstName" label={messages.firstNameLabel} value={value.firstName} onChange={this._handleFirstNameChange} error={errors.firstName} backendError={backendErrors.firstName} required inputProps={{
            autoComplete: "given-name"
        }}/>

				<TextFormGroup name="lastName" className="form-group-personalInfo-lastName" label={messages.lastNameLabel} value={value.lastName} onChange={this._handleLastNameChange} error={errors.lastName} backendError={backendErrors.lastName} required inputProps={{
            autoComplete: "family-name"
        }}/>

				<TextFormGroup name="address" label={messages.addressLabel} value={value.address} onChange={this._handleAddressChange} error={errors.address} backendError={backendErrors.address} required inputProps={{
            autoComplete: "address-line1"
        }}/>

				<TextFormGroup name="address2" label={messages.address2Label} value={value.address2} onChange={this._handleAddress2Change} error={errors.address2} backendError={backendErrors.address2} inputProps={{
            autoComplete: "address-line2"
        }}/>

				<TextFormGroup name="city" className="form-group-personalInfo-city" label={messages.cityLabel} help={messages.cityHelp} value={value.city} onChange={this._handleCityChange} error={errors.city} backendError={backendErrors.city} required inputProps={{
            autoComplete: "address-level2"
        }}/>

				<StateFormGroup name="state" className="form-group-personalInfo-state" label={messages.stateLabel} help={messages.stateHelp} value={value.state} onChange={this._handleStateChange} error={errors.state} backendError={backendErrors.stateProvince} required inputProps={{
            autoComplete: "address-level1"
        }}/>

				<TextFormGroup name="zip" className="form-group-personalInfo-zip" label={messages.zipLabel} help={messages.zipHelp} value={value.zip} onChange={this._handleZipChange} error={errors.zip} backendError={backendErrors.postalCode} required inputProps={{
            autoComplete: "postal-code"
        }}/>

				<PhoneFormGroup name="phone" label={messages.phoneLabel} help={messages.phoneHelp} value={value.phone} onChange={this._handlePhoneChange} error={errors.phone} backendError={backendErrors.phone} required inputProps={{
            autoComplete: "tel"
        }}/>

				{!props.hideEmail && (<TextFormGroup name="email" label={messages.emailLabel} value={value.email} onChange={this._handleEmailChange} error={errors.email} backendError={backendErrors.emailAddress} required inputProps={{
            autoComplete: "email"
        }}/>)}
			</Fragment>);
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/secure/PayNowForm/PersonalInfoFields/PersonalInfoFields.tsx